export const TIME_FORMATS = ['HH:mm', 'hh:mm A'] as const;

export type TimeFormat = (typeof TIME_FORMATS)[number];

export function isTimeFormat(value: unknown): value is TimeFormat {
    return typeof value === 'string' && TIME_FORMATS.includes(value as TimeFormat);
}

export function is12hFormat(value: TimeFormat): boolean {
    return value === 'hh:mm A';
}
